import { useSetAtom } from 'jotai';
import { useEffect } from 'react';

import { onConnectionDrop, subscribe } from '@/lib/desktop-sse';
import { extensionSSEAtom } from '@/store/atoms';

export const useExtensionSSE = () => {
  const setExtensionSSE = useSetAtom(extensionSSEAtom);

  useEffect(() => {
    const onExtension = (ev: MessageEvent) => {
      try {
        const payload = JSON.parse(ev.data);
        const extension = payload.extensionNumber;
        setExtensionSSE(extension);
      } catch (e) {
        console.warn('[DesktopSSE] Failed parsing extension event', e);
      }
    };

    const unsubscribe = subscribe(
      'extension',
      onExtension as unknown as (ev: MessageEvent) => void
    );

    const offDrop = onConnectionDrop(() => {
      setExtensionSSE(null);
    });

    return () => {
      setExtensionSSE(null);
      unsubscribe();
      offDrop();
    };
  }, [setExtensionSSE]);
};
